// fslightbox
import "fslightbox";

// Smooth Scroll Behavior Polyfill
import smoothscroll from "smoothscroll-polyfill";
// Swiper
import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
// Modules
import BodyScroll from "./modules/BodyScroll.js";
import { slideToggle } from "./modules/SlideBlock.js";
import "./modules/SetWindowHeight.js";

smoothscroll.polyfill();

Swiper.use([Navigation, Pagination, Autoplay]);

// Initiation
const bodyScroll = new BodyScroll();

// Hero video
document.addEventListener("DOMContentLoaded", function () {
  const videoElement = document.querySelector(".hero-video");

  if (videoElement) {
    if (videoElement.hasAttribute("poster")) {
      const loadVideo = () => {
        videoElement.src = videoElement.getAttribute("data-src");
        videoElement.load();
        document.removeEventListener("click", loadVideo);
        document.removeEventListener("scroll", loadVideo);
      };
      document.addEventListener("click", loadVideo);
      document.addEventListener("scroll", loadVideo);
    } else {
      videoElement.src = videoElement.getAttribute("data-src");
      videoElement.load();
    }
  }
});

/**
 * Header
 */
const header = document.querySelector("header.header");
if (header) {
  const topbar = document.querySelector(".topbar");
  const topbarHeight = topbar.getBoundingClientRect().height;

  const checkHeader = () => {
    const fromTop = window.scrollY;

    if (fromTop >= topbarHeight - 30) {
      header.classList.add("-scrolled");
    } else {
      header.classList.remove("-scrolled");
    }
  };

  checkHeader();

  window.addEventListener("scroll", () => checkHeader());
}

// Nav
const nav = document.querySelector(".header nav");
if (nav) {
  const subNavTriggers = nav.querySelectorAll("li.has-subnav > a");
  subNavTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      //arrow will act as dropdown, but the link will work as usually
      if (e.offsetX > trigger.offsetWidth - 50 && window.innerWidth < 992) {
        e.preventDefault();
      }

      if (window.innerWidth < 992) {
        trigger.parentElement.classList.toggle("active");
        slideToggle(trigger.nextElementSibling, 300);
      }
    });
  });

  const hamburger = document.querySelector(".hamburger");
  hamburger?.addEventListener("click", () => {
    if (hamburger.classList.contains("is-active")) {
      bodyScroll.unLock(300);
      hamburger.classList.remove("is-active");
      nav.classList.remove("active");
    } else {
      bodyScroll.lock(nav);
      hamburger.classList.add("is-active");
      nav.classList.add("active");
    }
  });
}

// Offers Slider
new Swiper(".offers-slider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 4000,
  },
  simulateTouch: true,
  spaceBetween: 10,
  slidesPerView: 1,
  watchSlidesProgress: true,
  loop: true,
  breakpoints: {
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    992: {
      spaceBetween: 25,
      slidesPerView: 3,
    },
    1400: {
      spaceBetween: 27,
      slidesPerView: 4,
    },
  },
});

// Reviews Slider
new Swiper(".reviews-slider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  simulateTouch: true,
  spaceBetween: 10,
  slidesPerView: 1,
  watchSlidesProgress: true,
  autoplay: true,
  draggable: true,
  loop: true,
  breakpoints: {
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    1170: {
      spaceBetween: 20,
      slidesPerView: 3,
    },
  },
});

// Reviews Slider
new Swiper(".reviews-items-slider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  simulateTouch: true,
  spaceBetween: 10,
  slidesPerView: 1,
  watchSlidesProgress: true,
  autoplay: true,
  draggable: true,
  loop: true,
  breakpoints: {
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    1170: {
      spaceBetween: 20,
      slidesPerView: 3,
    },
  },
});

// FAQ
const faqItems = document.querySelectorAll(".faq-item");
faqItems.forEach((item) => {
  const trigger = item.querySelector(".faq-item-trigger"),
    dropdown = item.querySelector(".faq-item-dropdown");

  trigger.addEventListener("click", function () {
    trigger.classList.toggle("active");
    slideToggle(dropdown, 300);
  });
});

// To Tpp
const toTopTriggers = document.querySelectorAll(".footer-to-top");
toTopTriggers.forEach((trigger) => {
  trigger.addEventListener("click", () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
});

// To book section on Escape Room click
document.addEventListener("DOMContentLoaded", function () {
  const bookButtons = document.querySelectorAll(".offers-card-btn-book");

  bookButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const offersCard = button.closest(".offers-card");
      const permalink = offersCard.getAttribute("href");
      window.location.href = permalink + "#reserveren";
    });
  });
});
